<template>
    <div class="wrapper blog-posts">
        <div class="page-header page-header signup-page section-image">
            <parallax class="page-header-image" style="background-image: url('img/homepage/trumpHero.jpg') ;">
            </parallax>
            <div class="content-center">
                <div class="row">
                    <div class="col-md-8 ml-auto mr-auto text-center">
                        <h2 class="title">Welcome to The System!</h2>
                        <h3 class="description"><b>You’re now subscribed to Australia’s most profitable horse racing service.</b></h3>
                        <h3 class="description"><b>Check your emails including your junk/spam/promotions folder for an instructional email and tipping links.</b></h3>
                        <h3 class="description"><b>We cant wait to see you in our tipping channel!</b></h3>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import { Card, Button, FormGroupInput } from '@/components';
  import { Carousel, CarouselItem, Table, TableColumn } from 'element-ui'
  import Sidebar from '@/pages/bet/sidebar';
  import db from '../../components/Firebase/firebaseInit'
  
  export default {
    name: 'blog-posts',
    bodyClass: 'blog-posts',
    components: {
      Card,
      Sidebar,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Button.name]: Button,
      [FormGroupInput.name]: FormGroupInput
    },
    data() {
      return {
        year: new Date().getFullYear(),
        freeCompetions: []
      }
    },
    created(){
    db.collection('freeCompetions').get()
    .then(querySnapshot => {
      querySnapshot.forEach(doc => {
        const data = {
          'id': doc.id,
          'title': doc.data().title,
          'content': doc.data().content,
          'link': doc.data().link
        }
        this.freeCompetions.push(data)
      })
    })
    }
  }
</script>
<style>
</style>
